/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios'
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// PD-0003 Fase 4 - control plane de gestao de tenants (Master, /central/**, super-admin global).
// NAO enviam X-TENANT-ID (herdam so o Authorization dos defaults). Datas de query em dd/MM/yyyy.

export const getRankingTenants = async (
  cancel: any,
  dataInicio: string,
  dataFim: string,
  fases: string[],
  ativo?: boolean
): Promise<RankingTenantsType | { message: string }> => {
  try {
    const result = await apiService.get('central/gestao-tenants/ranking', {
      cancelToken: cancel.token,
      params: {
        ...(dataInicio ? { dataInicio } : {}),
        ...(dataFim ? { dataFim } : {}),
        ...(fases && fases.length > 0 ? { fases } : {}),
        ...(ativo !== undefined ? { ativo } : {}),
      },
      // Multivalor por repeat (?fases=EM_FUNCIONAMENTO&fases=STANDBY) - mesma convencao do resto.
      paramsSerializer: params =>
        Qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getDrilldownTenant = async (
  cancel: any,
  tenantId: string,
  dataInicio: string,
  dataFim: string,
  granularidade: string
): Promise<DrilldownTenantType | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/gestao-tenants/tenant/${tenantId}`,
      {
        cancelToken: cancel.token,
        params: {
          ...(dataInicio ? { dataInicio } : {}),
          ...(dataFim ? { dataFim } : {}),
          ...(granularidade ? { granularidade } : {}),
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getStatusRollup = async (
  cancel: any
): Promise<RecalculoStatusType | { message: string }> => {
  try {
    const result = await apiService.get('central/gestao-tenants/status', {
      cancelToken: cancel.token,
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// Recalculo assincrono. 202 = disparado (iniciado=true); 409 = ja em andamento (iniciado=false) -
// NAO e erro: devolve o corpo RecalculoStatusType para o hook tratar como estado neutro.
const tratarRespostaRecalculo = (
  error: unknown
): RecalculoStatusType | { message: string } => {
  if (axios.isAxiosError(error) && error.response?.status === 409) {
    return error.response.data as RecalculoStatusType
  }
  return catchError(error)
}

export const postRecalcularTenants = async (): Promise<
  RecalculoStatusType | { message: string }
> => {
  try {
    const result = await apiService.post('central/gestao-tenants/recalcular')
    if (result.status === 202 || result.status === 200) {
      return result.data
    }
  } catch (error) {
    return tratarRespostaRecalculo(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const postRecalcularTenant = async (
  tenantId: string
): Promise<RecalculoStatusType | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/gestao-tenants/tenant/${tenantId}/recalcular`
    )
    if (result.status === 202 || result.status === 200) {
      return result.data
    }
  } catch (error) {
    return tratarRespostaRecalculo(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}
